// extracted by mini-css-extract-plugin
export default {"navButton":"nav-button_navButton__9D7hi","text":"nav-button_text__AtdoJ","active":"nav-button_active__5G9Xa"};